/* Native playback stays usable without JS; this component adds an error fallback. */
if (!customElements.get('otsm-text-video')) {
  customElements.define('otsm-text-video', class extends HTMLElement {
    connectedCallback() {
      this.listeners?.abort();
      this.listeners = new AbortController();
      const video = this.querySelector('video');
      const status = this.querySelector('[role="status"]');
      if (!video || !status) return;
      const fail = () => {
        const focused = document.activeElement === video;
        video.pause();
        video.hidden = true;
        status.hidden = false;
        if (focused) {
          status.tabIndex = -1;
          status.focus();
        }
      };
      const options = { signal: this.listeners.signal };
      video.addEventListener('error', fail, options);
      const sources = [...video.querySelectorAll('source')];
      const failedSources = new Set();
      sources.forEach((source) => source.addEventListener('error', () => {
        failedSources.add(source);
        // A failed codec/source must not hide another playable source.
        if (failedSources.size === sources.length && video.readyState === 0) fail();
      }, options));
      if (video.error) fail();
      if (this.hasAttribute('data-autoplay')) this.setupAutoplay(video, options);
    }

    // Muted loop that only plays (and only downloads) while the panel is on screen.
    setupAutoplay(video, options) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.controls = true;
        return;
      }
      video.muted = true;
      if (!('IntersectionObserver' in window)) {
        video.play().catch(() => { video.controls = true; });
        return;
      }
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          video.play().catch(() => { video.controls = true; });
        } else {
          video.pause();
        }
      }, { rootMargin: '200px 0px' });
      observer.observe(this);
      options.signal.addEventListener('abort', () => observer.disconnect());
    }

    disconnectedCallback() {
      this.listeners?.abort();
      this.querySelector('video')?.pause();
    }
  });
}
